module.exports = __webpack_public_path__ + "img/Balance.7fa52c9c.svg";